/* =============================================================
   Pulse Performance — Free gift auto-add (helper for a native
   Buy X Get Y discount, currently "D3+K2 zdarma nad 1.000 Kč")
   ---------------------------------------------------------------
   Shopify's BXGY discount zeroes the gift line's price but never
   adds the "Customer gets" item itself. This script only adds /
   removes / clamps that line. It never changes a price: pricing is
   100% the native discount.

   Config: <script id="FreeGiftConfig"> from snippets/free-gift-config.liquid,
   which also loads this file — only when the "Free gift" theme setting is on,
   the market is CZ and the gift has an available variant. No config → no-op.

   Rules (per reconcile, after GET /cart.js):
   - cart currency must be CZK, else nothing.
   - trigger "quantity": Σ quantity of qualifying lines (gift line excluded) ≥ minQty.
   - trigger "amount" (default):
     qualifyingAmount = Σ original_line_price of lines whose product is in a
     qualifying collection, EXCLUDING the free gift line (_free_gift = "true").
     original_line_price, because the discount combines with nothing: while the
     gift is free no other line discount can exist, so pre/post-discount are
     equal, and original_line_price doesn't flip when a code is entered.
     A PAID gift product counts (verified against the live discount).
   - ≥ min and no gift line → add 1 (unless dismissed / gave up / suppressed).
   - < min, influencer account (window.ppFreeGiftBlocked) or gift alone → remove.
   - gift qty > 1 or several gift lines → drop them all (fresh line keys each
     time; Shopify splits a qty-3 gift into free + paid lines) and add one.
   - gift line still priced > 0 (the discount isn't applying, e.g. a code won or the
     discount isn't live) → remove it so nobody pays for a "free" gift; don't re-add
     while the cart's discount codes stay the same (kept in sessionStorage, so a reload
     doesn't re-add it). After our own add the cart is checked once more, so this
     happens immediately.
   - Lines with the legacy _auto_gift flag (old Powerfuel+Kreatin promo) are removed,
     and so is any _free_gift line whose variant isn't the current gift (stale gift).
   - cleanupOnly config (gift not active here but the cart holds gift lines): remove all
     gift lines, nothing else, on any market.
   - Customer removes the gift → sessionStorage "pulse_free_gift_dismissed",
     not re-added this session; flag cleared when the cart becomes empty.
   - Add fails (sold out / unavailable) → stop for this page view.
   Cart bar: window.PulseFreeGift.restore() (button [data-free-gift-restore]) undoes a
   dismissal; <html data-free-gift-dismissed> mirrors the flag for CSS.
   Wiring: page load, pageshow (bfcache), every cart-update pub/sub event
   (every add/change path in the theme publishes one). Own refreshes are
   ignored, in-flight lock + 300 ms debounce. Fails silently (console.warn).
   ============================================================= */
(function () {
  'use strict';

  var cfgEl = document.getElementById('FreeGiftConfig');
  if (!cfgEl || window.__pulseFreeGift) return;
  window.__pulseFreeGift = true;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return warn('bad config', e);
  }
  var FLAG = '_free_gift';
  var LEGACY_FLAG = '_auto_gift';
  var DISMISS_KEY = 'pulse_free_gift_dismissed';
  var DEBOUNCE_MS = 300;
  var qualifying = {};
  (CFG.qualifyingProductIds || []).forEach(function (id) { qualifying[String(id)] = true; });

  var busy = false;
  var again = false;
  var timer = null;
  var gaveUp = false;          // add failed → stop for this page view
  var suppressedFor = null;    // discount-code signature while the gift wasn't free
  var SUPPRESS_KEY = 'pulse_free_gift_not_free'; // same, kept for the tab session: "<gift variant>|<codes>"
  var giftSeen = false;        // a gift line existed at the last reconcile
  var othersSeen = null;       // signature of the non-gift lines at that moment
  var refreshing = 0;          // our own UI refresh in flight → ignore its echo
  var lastAmount = null;       // qualifying amount from the last plan() (drift alarm)
  var verifyAfterAdd = false;  // one follow-up check after our own add (safety net)

  function warn(msg, e) {
    try { console.warn('[free-gift] ' + msg, e || ''); } catch (x) {}
  }
  function store(fn) {
    try { return fn(window.sessionStorage); } catch (e) { return null; }
  }
  var isDismissed = function () { return store(function (s) { return s.getItem(DISMISS_KEY) === '1'; }) === true; };
  // <html data-free-gift-dismissed> lets CSS show the cart bar's "Přidat dárek" button
  // (snippets/cart-progress.liquid) across footer re-renders without more JS.
  var syncDismissedAttr = function () {
    try { document.documentElement.toggleAttribute('data-free-gift-dismissed', isDismissed()); } catch (e) {}
  };
  var dismiss = function () { store(function (s) { s.setItem(DISMISS_KEY, '1'); }); syncDismissedAttr(); };
  var undismiss = function () { store(function (s) { s.removeItem(DISMISS_KEY); }); syncDismissedAttr(); };

  // Drift alarm (debug only: ?free_gift_debug=1, kept for the tab session): the cart bar
  // renders its own Liquid-computed qualifying amount; warn if it differs from ours.
  var debug = false;
  try {
    var dm = /[?&]free_gift_debug=([01])(?:&|$)/.exec(window.location.search);
    if (dm) window.sessionStorage.setItem('free_gift_debug', dm[1]);
    debug = window.sessionStorage.getItem('free_gift_debug') === '1';
  } catch (e) {}
  function checkDrift(amount, cart) {
    if (!debug) return;
    var el = document.querySelector('[data-free-gift-amount]');
    if (!el || el.getAttribute('data-free-gift-items') !== String(cart.item_count)) return; // bar not yet re-rendered for this cart
    var bar = parseInt(el.getAttribute('data-free-gift-amount'), 10);
    if (bar !== amount) warn('drift: cart bar amount ' + bar + ' ≠ script amount ' + amount);
    else console.log('[free-gift] bar and script agree: ' + amount);
  }

  function isGift(item) {
    return !!(item.properties && item.properties[FLAG] === 'true');
  }
  function isLegacy(item) {
    return !!(item.properties && item.properties[LEGACY_FLAG]);
  }
  function othersSig(lines) {
    return lines.map(function (i) { return i.variant_id + 'x' + i.quantity; }).sort().join(',');
  }
  function suppressSig(cart) {
    return String(CFG.giftVariantId) + '|' + codesSig(cart);
  }
  function isSuppressed(cart) {
    if (suppressedFor === codesSig(cart)) return true;
    return store(function (s) { return s.getItem(SUPPRESS_KEY); }) === suppressSig(cart);
  }
  function suppress(cart) {
    suppressedFor = codesSig(cart);
    store(function (s) { s.setItem(SUPPRESS_KEY, suppressSig(cart)); });
  }
  function codesSig(cart) {
    return (cart.discount_codes || []).map(function (d) { return d.code; }).sort().join('|');
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, data: j }; });
    });
  }
  function changeLine(key, quantity) {
    return postJson((window.routes && window.routes.cart_change_url) || '/cart/change.js', { id: key, quantity: quantity });
  }

  /* Decide what to do with this cart; returns a list of mutations. */
  function plan(cart) {
    var ops = [];
    var items = cart.items || [];

    // Cleanup-only mode (gift not active here, but the cart holds gift lines): remove
    // every _free_gift / _auto_gift line and do nothing else.
    if (CFG.cleanupOnly) {
      items.filter(function (i) { return isGift(i) || isLegacy(i); })
        .forEach(function (i) { ops.push({ type: 'remove', key: i.key, why: 'cleanup-only: gift not active' }); });
      return ops;
    }

    // A gift line for a variant that isn't the current gift (e.g. the previous promo's
    // gift) is stale: remove it so nobody pays for a former "gift".
    var isCurrentGift = function (i) { return isGift(i) && String(i.variant_id) === String(CFG.giftVariantId); };
    items.filter(function (i) { return isGift(i) && !isCurrentGift(i); })
      .forEach(function (i) { ops.push({ type: 'remove', key: i.key, why: 'stale gift (not the current gift variant)' }); });
    var gifts = items.filter(isCurrentGift);
    var others = items.filter(function (i) { return !isGift(i) && !isLegacy(i); });
    items.filter(isLegacy).forEach(function (i) { ops.push({ type: 'remove', key: i.key, why: 'legacy _auto_gift' }); });

    if (!items.length) { undismiss(); store(function (st) { st.removeItem(SUPPRESS_KEY); }); }

    var removeAllGifts = function (why) {
      gifts.forEach(function (g) { ops.push({ type: 'remove', key: g.key, why: why }); });
    };
    if (window.ppFreeGiftBlocked === true) { removeAllGifts('blocked account'); return ops; }
    if (!others.length) {
      undismiss();
      removeAllGifts('gift alone');
      return ops;
    }

    if (CFG.trigger === 'quantity') {
      // quantity trigger: Σ quantity of qualifying lines (gift line excluded) ≥ minQty
      var qty = others.reduce(function (sum, i) {
        return qualifying[String(i.product_id)] ? sum + (i.quantity || 0) : sum;
      }, 0);
      if (qty < (CFG.minQty || 1)) { removeAllGifts('below minimum quantity'); return ops; }
    } else {
      var amount = others.reduce(function (sum, i) {
        return qualifying[String(i.product_id)] ? sum + (i.original_line_price || 0) : sum;
      }, 0);
      lastAmount = amount;
      if (amount < CFG.minAmountCents) { removeAllGifts('below minimum'); return ops; }
    }

    if (!gifts.length) {
      // gone while every other line is unchanged → the customer removed it themselves
      // (a rebuilt cart — cleared and refilled elsewhere — is not a dismissal)
      if (giftSeen && othersSeen === othersSig(others)) { dismiss(); return ops; }
      if (isDismissed() || gaveUp || isSuppressed(cart)) return ops;
      ops.push({ type: 'add', why: 'minimum reached' });
      return ops;
    }

    var giftQty = gifts.reduce(function (s, g) { return s + g.quantity; }, 0);
    if (gifts.length > 1 || giftQty !== 1) {
      // qty > 1 makes Shopify split the gift into a free and a paid line, and line keys
      // change after every edit → drop all gift lines (fresh keys each time), add one.
      ops.push({ type: 'reset', why: 'clamp to 1' });
      return ops;
    }
    if (gifts[0].final_line_price > 0) {
      suppress(cart);
      ops.push({ type: 'remove', key: gifts[0].key, why: 'gift not free (discount not applying)' });
    }
    return ops;
  }

  function run(ops) {
    var chain = Promise.resolve();
    var changed = false;
    var addGift = function () {
      return postJson((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        id: CFG.giftVariantId,
        quantity: 1,
        properties: (function () { var p = {}; p[FLAG] = 'true'; return p; })()
      }).then(function (r) {
        if (!r.ok || (r.data && r.data.status)) { gaveUp = true; warn('gift add failed, giving up for this page view', r.data && r.data.description); return; }
        changed = true;
      });
    };
    var dropGiftLines = function (left) {
      return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
        var g = (c.items || []).filter(isGift)[0];
        if (!g || left <= 0) return;
        return changeLine(g.key, 0).then(function (r) {
          if (!r.ok) return warn('gift line removal failed', r.data && r.data.description);
          changed = true;
          return dropGiftLines(left - 1);
        });
      });
    };
    ops.forEach(function (op) {
      chain = chain.then(function () {
        if (op.type === 'reset') return dropGiftLines(5).then(addGift);
        if (op.type === 'add') return addGift();
        return changeLine(op.key, 0).then(function (r) {
          if (r.ok) changed = true;
          else warn('cart change failed (' + op.why + ')', r.data && r.data.description);
        });
      });
    });
    return chain.then(function () { return changed; });
  }

  function refreshUI() {
    refreshing++;
    var done = function () { setTimeout(function () { refreshing--; }, 0); };
    try {
      if (typeof window.refreshDawnCartUI === 'function') {
        // theme utility: re-renders every mounted cart section (cart page footer,
        // cart icon …) and publishes cart-update → cart.js re-renders the item list
        return Promise.resolve(window.refreshDawnCartUI()).then(done, done);
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cartData: cart });
        }).then(done, done);
      }
    } catch (e) {
      warn('UI refresh failed', e);
    }
    done();
    return Promise.resolve();
  }

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return false;
        // cleanup-only runs on every market; the gift logic only in CZK
        if (!CFG.cleanupOnly && cart.currency !== (CFG.currency || 'CZK')) return false;
        lastAmount = null;
        var ops = plan(cart);
        if (lastAmount !== null) checkDrift(lastAmount, cart);
        return run(ops).then(function (changed) {
          // remember whether a gift line is in the cart now, so a later reconcile
          // that finds it gone (with the minimum still met) knows the customer removed it
          var removed = ops.filter(function (o) { return o.type === 'remove'; }).map(function (o) { return o.key; });
          var added = ops.some(function (o) { return o.type === 'add' || o.type === 'reset'; }) && !gaveUp;
          giftSeen = added || (cart.items || []).some(function (i) { return isGift(i) && removed.indexOf(i.key) === -1; });
          othersSeen = othersSig((cart.items || []).filter(function (i) { return !isGift(i) && !isLegacy(i); }));
          if (!changed) return false;
          return refreshUI().then(function () {
            // We just added a gift: check the cart once more, so a gift the discount doesn't
            // make free is removed right away (not only on the next cart event). The follow-up
            // can only remove, never add again, so this can't loop.
            if (added) verifyAfterAdd = true;
          });
        });
      })
      .catch(function (e) { warn('reconcile failed', e); })
      .then(function () {
        busy = false;
        if (verifyAfterAdd) { verifyAfterAdd = false; again = false; schedule(); return; }
        if (again) { again = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, DEBOUNCE_MS);
  }

  // "Přidat dárek" in the cart bar: undo a dismissal and run the normal logic again.
  window.PulseFreeGift = {
    restore: function () {
      undismiss();
      gaveUp = false;
      suppressedFor = null;
      giftSeen = false;
      schedule();
    }
  };

  function init() {
    try {
      syncDismissedAttr();
      document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-free-gift-restore]');
        if (!btn) return;
        e.preventDefault();
        btn.disabled = true;
        window.PulseFreeGift.restore();
      });
      reconcile();
      window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.source === 'free-gift') return;
          if (refreshing && event && event.source === 'external-refresh') return; // echo of our own refresh
          schedule();
        });
      }
    } catch (e) {
      warn('init failed', e);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
